// extracted by mini-css-extract-plugin
export default {"dragWrapper":"abf52d1a6973ef71","dragContent":"a48e7855e0059512","dragText":"_8b06359b1915dcf6","dragIcon":"_7c483d8a31a313bc"};